import WebAuthnController from "stimulus-web-authn";
import { Turbo } from "@hotwired/turbo-rails";

export default class extends WebAuthnController {
  onCompletion(response) {
    Turbo.visit(response.location, { action: "replace" });
  }
}
